import { KeyRounded } from '@mui/icons-material';
import { Avatar, Box, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { setSelectedItem } from 'app/actions/token';
import { Autosizer, Scrollbar } from 'app/components';
import { selectedItemTokenSelector, sortItemsTokenSelector } from 'app/selectors/token';
import React, { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';
const TokenList = () => {
    const dispatch = useDispatch();
    const selectedItem = useSelector(selectedItemTokenSelector);
    const sortItems = useSelector(sortItemsTokenSelector);
    const handleItemClick = (value) => dispatch(setSelectedItem(value));
    return (React.createElement(Box, { component: 'div', sx: (theme) => ({
            width: '100%',
            height: '100%',
            padding: theme.spacing(0),
            '.MuiListItem-root': {
                width: '100%',
                userSelect: 'none',
                padding: theme.spacing(0),
                borderRadius: '0',
                '.MuiListItemAvatar-root': {
                    minWidth: '36px',
                },
                '.MuiAvatar-circular': {
                    width: '24px',
                    height: '24px',
                    color: theme.palette.primary.main,
                    bgcolor: alpha(theme.palette.primary.main, 0.12),
                    svg: {
                        fontSize: '16px',
                    },
                },
                '.MuiListItemButton-root': {
                    padding: theme.spacing(1, 2),
                    borderRadius: '0',
                },
                '.MuiListItemText-root': {
                    margin: theme.spacing(0),
                },
            },
        }) },
        React.createElement(Autosizer, null, ({ height, width }) => (React.createElement(Box, { sx: { height, width } },
            React.createElement(Scrollbar, null, ({ scrollableNodeRef, contentNodeRef }) => (React.createElement(FixedSizeList, { height: height, itemSize: 36, itemCount: sortItems.length, innerRef: contentNodeRef, outerRef: scrollableNodeRef, innerElementType: tokenListInnerElementType, itemData: {
                    items: sortItems,
                    selectedItem,
                    onClick: handleItemClick,
                } }, TokenListItemRender))))))));
};
const tokenListInnerElementType = forwardRef((props, ref) => (React.createElement(List, Object.assign({ ref: ref, disablePadding: true }, props))));
tokenListInnerElementType.displayName = 'TokenListInnerElementType';
const TokenListItemRender = ({ data, index, style }) => {
    const { items, selectedItem, onClick } = data;
    const item = items[index];
    return (React.createElement(ListItem, { key: item.id, style: style, selected: item.id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id), onClick: () => onClick(item) },
        React.createElement(ListItemButton, null,
            React.createElement(ListItemAvatar, null,
                React.createElement(Avatar, null,
                    React.createElement(KeyRounded, null))),
            React.createElement(ListItemText, { primary: item.name }))));
};
export default TokenList;
